import {rejectGenericError} from 'shared/req';
import {changesSaved, errorMessage} from 'shared/actions/notifications';
import StudentService from 'src/services/StudentService';
import {receiveStudent} from 'shared/actions/student';
import {RECEIVE_INSTITUTION, UPDATE_CURRENT_INSTITUTION} from 'portfolio/actions/institution';

export const saveAboutMe = (student) => async (dispatch) => {
  const fields = [
    '_id',
    'firstName',
    'lastName',
    'currentInstitution',
    'highSchoolInfo',
    'academicInterestIds',
    'communityCollegeInfo',
    'undergraduateInfo',
    'image',
    'bio',
    'academicInterests',
  ].join(',');

  try {
    const updatedStudent = await StudentService.update('me', student, {fields});
    if (updatedStudent.currentInstitution.campus) {
      updatedStudent.currentInstitution.campus = JSON.parse(
        updatedStudent.currentInstitution.campus
      );
    }
    dispatch(receiveStudent(updatedStudent));
    dispatch({type: RECEIVE_INSTITUTION, institution: updatedStudent.currentInstitution});
    dispatch({type: UPDATE_CURRENT_INSTITUTION, institution: updatedStudent.currentInstitution});
    dispatch(changesSaved());
  } catch {
    dispatch(errorMessage());
    rejectGenericError();
  }
};
